import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingCampaignsQueryKey } from './get-campaigns';
import { type WorkflowMarketingCampaign } from './get-workflow-campaign';

type SaveCampaignPayload = {
  MarketingCampaignId: number;
};

type SaveCampaignResponse = WorkflowMarketingCampaign;

export function useDuplicateWorkflowCampaignMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { marketingCampaignId: number }) => {
      const res = postData<SaveCampaignPayload, SaveCampaignResponse>({
        endpoint: 'api/marketing-campaign/duplicate-workflow-campaign',
        payload: { MarketingCampaignId: params.marketingCampaignId },
      });
      return res;
    },
    onSuccess: () => queryClient.invalidateQueries(marketingCampaignsQueryKey),
  });
}
